// orderSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchOrder, fetchOrderByID, orderUser } from '../../services/orderService';


const orderSlice = createSlice({
    name: 'order',
    initialState: {
        orders: [],
        status: '',
        loader : true,
        order : null,
        pagination: {
          current_page: 1,
          limit: 9,
          total_items: 0,
          total_pages: 0
          }
    },
    reducers: {
    },
    extraReducers : (builder) => {
        builder
        .addCase(orderUser.pending, (state) => {
            state.loader = true
        })
        .addCase(orderUser.fulfilled, (state, action) => {
            state.status = "success";
            state.orders = action.payload.data;
            state.loader = false
            state.loader = false;
            state.pagination = action.payload.pagination
          })
          .addCase(orderUser.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.payload;
            state.loader = false
          })
          .addCase(fetchOrderByID.pending, (state) => {
            state.loader = true
        })
        .addCase(fetchOrderByID.fulfilled, (state, action) => {
            state.status = "success";
            state.order = action.payload;
            state.loader = false
          })
          .addCase(fetchOrderByID.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.payload;
            state.loader = false
          })
    }
});


export default orderSlice.reducer;
